import { css } from '@emotion/react'
import { mq } from 'plume-ui'
import React from 'react'
import { EmployeesShiftData } from '../../../../types/api'
import { A } from '../../../atoms/A'
import { Table, TableCell, TableHeading } from '../../../atoms/Table'
import { EmptyCard } from '../../../common/EmptyCard'
import { Help } from '../../../common/Help'
import { LimitedToEnterpriseContents } from '../../../common/LimitedToEnterpriseContents'
import { FormattedDate } from '../../../atoms/FormattedDate'

type Props = {
  employeesShift: EmployeesShiftData[]
  isEnterprise: boolean
}

export const EmployeesShiftTable: React.FC<Props> = (props) => {
  if (!props.isEnterprise) {
    return (
      <Table>
        <thead
          css={css`
            ${mq.untilMedium} {
              display: ${props.isEnterprise ? 'initial' : 'none'};
            }
          `}
        >
          <tr>
            <TableHeading />
            <TableHeading>年月日</TableHeading>
            <TableHeading>
              区分
              <Help>従業員数の集計方法</Help>
            </TableHeading>
            <TableHeading>
              従業員数
              <Help>臨時雇用者を含みます</Help>
            </TableHeading>
            <TableHeading>出所</TableHeading>
            <TableHeading>備考</TableHeading>
          </tr>
        </thead>
        <tbody
          css={css`
            ${mq.untilMedium} {
              display: flex;
              justify-content: center;
            }
          `}
        >
          <tr>
            <TableCell colSpan={6} align="center">
              <LimitedToEnterpriseContents />
            </TableCell>
          </tr>
        </tbody>
      </Table>
    )
  }
  if (props.employeesShift.length === 0) {
    return <EmptyCard />
  }

  return (
    <Table>
      <thead>
        <tr>
          <TableHeading />
          <TableHeading>年月日</TableHeading>
          <TableHeading>
            区分
            <Help>従業員数の集計方法</Help>
          </TableHeading>
          <TableHeading>
            従業員数
            <Help>臨時雇用者を含みます</Help>
          </TableHeading>
          <TableHeading>出所</TableHeading>
          <TableHeading>備考</TableHeading>
        </tr>
      </thead>
      <tbody>
        {props.employeesShift.map((data, i) => (
          <tr key={i} id={employeesShiftTableRecordId(data)}>
            <TableCell>{data.dateType}</TableCell>
            <TableCell>
              <FormattedDate>{data.eventDate}</FormattedDate>
            </TableCell>
            <TableCell>{data.reportType}</TableCell>
            <TableCell>{data.count.toLocaleString()}人</TableCell>
            <TableCell>
              {data.sourceUrl ? (
                <A
                  href={data.sourceUrl}
                  target="_blank"
                  rel="noopener"
                  decoration="none"
                >
                  {data.sourceType}
                </A>
              ) : (
                <>{data.sourceType}</>
              )}
            </TableCell>
            <TableCell>{data.remarks}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export const employeesShiftTableRecordId = (
  employeesShiftData: EmployeesShiftData
) => {
  return `employees-${employeesShiftData.eventDate}-${employeesShiftData.reportType}`
}
